<script>
    import { onMount } from "svelte";
    import { emitter } from "../stores.js";
    import {querystring, link, location, push, pop, replace} from 'svelte-spa-router';


    export let chipsdata;

    onMount(async () => {
        console.log(chipsdata);
        // console.log(chipsdata['sz']);

        // for(let i = 0; i < chipsdata.length; i++){
        //     if(chipsdata[i].s === true && chipsdata[i].cbf !== undefined) chipsdata[i].cbf();            
        // }
    });

    function doChipClick(idx){
        select(idx);        
        if(chipsdata[idx].n !== undefined){
            push(chipsdata[idx].n );
        }
    }
    
    function select(idx) {
        // console.log("doing select")
        for(let i = 0; i < chipsdata.length; i++){
            chipsdata[i].s = false;
            if(i === idx){
                chipsdata[i].s = true;
                if(chipsdata[i].cbf !== undefined){
                    chipsdata[i].cbf();
                }
            } 
        }
        // console.log("dispatching progressClick");
        // const next_page = (chipsdata[idx].np !== undefined) ? chipsdata[idx].np : '';
        // $emitter.emit('progressClick', '');
        // dispatch('progressClick', {});
        // console.log(chipsdata);
    }

</script>

<div class="maincontainer">

    {#each chipsdata as chip, index}
    <div on:click={()=>{doChipClick(index);}} class="raise {(chip.s) ? "selected" : ""} chip {(index !== 0) ? "rightchipcontainer" : ""}">

        {#if chip.title }
        <div class="chiptitlecontianer">{chip.title}</div>        
        {:else}
        <div class="chipimagecontainer"><img class="{(chip['sz'] === "med") ? "mediumimage" : ""}" alt="left" src="{chip.i}"/></div>
        {/if}

        <div class="chiptextcontainer">{chip.t}</div>
    </div>
        
    {/each}
    
</div>

<style>
.maincontainer {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.chip {
    margin-top: 20px;
    border-radius: 5px;
    height: 130px;
    width: 130px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    padding: 15px;
    font-size: 1em;
    cursor: pointer;
    background-color: white;
    color: #2c313d;
    border: solid 1px;
    border-color: #2c313d;
    /* position: relative; */
}
.chip img {
    width: 75px;
    height: 75px;
}
.chipimagecontainer {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.chiptitlecontianer {
    margin-top: 35%;
    font-size: 1.5em;
    font-weight: 700;
    /* position: absolute; */
    /* top: 50%; */
    /* left: 50%; */
    /* transform: translate(-50%, -50%); */
}
:global(img.mediumimage){
    width: 40px !important;
    height: 40px !important;
}
/* .selected {
    background-color: #2c313d;
    color: white;
} */
.chip:hover {
    background-color: #2c313d;
    color: white;
}
/* .chip:hover img, .selected img {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(296deg) brightness(106%) contrast(101%);
} */
.chip:hover img {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(296deg) brightness(106%) contrast(101%);
}

.rightchipcontainer {
    margin-left: 20px;
}

@media (max-device-width: 1200px), (max-width: 1199px) {
    .maincontainer {
        width: 90vw;
        /* margin-left: auto; */
        /* margin-right: auto; */
    }
    .chip {
        width: 96px;
        height: 96px;
        font-size: .5em;
    }
    .chip img {
        width: 52px;
        height: 52px;
    }
    .chiptitlecontianer {
        font-size: 2em;
    }
    .chiptextcontainer {
        font-size: 1.25em;
        font-weight: 500;
    }
}


</style>